/**
 * Rule layers gated behind "available soon" for the paths-focused launch. The
 * Rules tab only lets a rule target PATHS for now, so no rule can impact landers
 * or offers. To re-enable lander/offer rule targeting later, empty
 * RULE_LAYERS_COMING_SOON (RULE_LAYERS_AVAILABLE derives from it). Do not delete.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FlowLayer } from '@trafficpulse/shared';

/** Layers a rule cannot target yet — locked + shown "· soon" in the Rules tab. */
export const RULE_LAYERS_COMING_SOON: ReadonlyArray<FlowLayer> = ['landers', 'offers'];

/** Layers a rule can still target during the launch (paths only for now). */
export const RULE_LAYERS_AVAILABLE: ReadonlyArray<FlowLayer> = (
  ['paths', 'landers', 'offers'] as FlowLayer[]
).filter((l) => !RULE_LAYERS_COMING_SOON.includes(l));
